import { useQuery } from '@apollo/client';
import { buildRawQueryStringified } from '@blaze-cms/react-page-builder';

import { GET_SEARCH_PUBLISHED_CONTENT } from '../../../services/querys';
import { getIdsFromBuckets } from '../helpers';

const MAX_CHUNK_SIZE = 150;

const useGetIdsOnProducts = ({
  mustFilters = [],
  parentLoading,
  featuredOnly,
  relationProperty,
  limit,
  useRandomSort
}) => {
  let rawQueryStringified = buildRawQueryStringified(
    [relationProperty],
    [],
    'published_product',
    mustFilters
  );

  const parsedQuery = JSON.parse(rawQueryStringified);
  if (limit) parsedQuery.aggs[relationProperty].terms.size = limit; // force bucket size to limit

  parsedQuery.aggs[relationProperty].terms.order = {
    _key: 'asc'
  };

  if (useRandomSort) {
    // random sort bucket results
    parsedQuery.aggs[relationProperty].terms.order = {
      'rnd.max': 'asc'
    };
    parsedQuery.aggs[relationProperty].aggs = {
      rnd: {
        stats: {
          script: 'Math.random()'
        }
      }
    };
  }

  rawQueryStringified = JSON.stringify(parsedQuery);

  const { data: aggsData = {}, loading: aggsLoading } = useQuery(GET_SEARCH_PUBLISHED_CONTENT, {
    variables: { rawQueryStringified, limit: 0 },
    skip: !rawQueryStringified || parentLoading
  });

  const recordIds = getIdsFromBuckets(aggsData, relationProperty);

  const where = [];
  for (let i = 0; i < recordIds.length; i += MAX_CHUNK_SIZE) {
    const chunk = recordIds.slice(i, i + MAX_CHUNK_SIZE);
    const newWhere = { id: { _in: chunk } };
    if (featuredOnly) newWhere.featured = true;
    where.push(newWhere);
  }

  return { aggsLoading, where, recordIds: useRandomSort ? recordIds : null };
};

export default useGetIdsOnProducts;
